import { useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import { UseMeasureRect } from 'react-use/lib/useMeasure';

const defaultState: UseMeasureRect = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
};

interface UseMeasureProps {
  enabled?: boolean;
}
export function useMeasure<T extends Element>({ enabled = true }: UseMeasureProps = {}) {
  const [element, ref] = useState<T | null>(null);
  const [rect, setRect] = useState<UseMeasureRect>(defaultState);

  useIsomorphicLayoutEffect(() => {
    if (!element || !enabled) return;
    const observer = new ResizeObserver((entries) => {
      if (entries[0]) {
        const { blockSize: height, inlineSize: width } = entries[0].borderBoxSize[0];
        const { x, y, top, left, bottom, right } = entries[0].target.getBoundingClientRect();
        setRect({ x, y, width, height, top, left, bottom, right });
      }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, enabled]);

  return [ref, rect] as const;
}
